<template>
  <div class="Background">
    <UserInfo v-if="userStatus === 'admin'" />
    <GuestForm v-else />
  </div>
</template>

<script>
import UserInfo from '@/components/user/UserInfo.vue';
import GuestForm from '@/components/user/GuestForm.vue';


export default {
  components: {
    UserInfo,
    GuestForm
  },
  created() {
    this.checkUserStatus();
  },
  data() {
    return {
      userStatus: null
    };
  },
  methods: {
    checkUserStatus() {
      this.$store.dispatch('user/adminCheck').then(() => {
        this.userStatus = this.$store.getters['user/userStatus'];
      }).catch(() => {
        this.userStatus = 'guest';
      });
    }
  }
}
</script>

<style lang="scss" scoped></style>